<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Joules</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="1400px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Ingreso</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              
              <template>
                <div>
                  <v-form v-model="valid">
                    <v-data-table
                      disable-initial-sort
                      :headers="headers2"
                      :items="item"
                      :pagination.sync="pagination"
                      class="elevation-2"
                    >
                      <template v-slot:items="props" >
                        <td>
                          <v-text-field
                            v-model="props.item.joules"
                            label=""
                            required
                          ></v-text-field>
                        </td>
                        <td class="justify-center"> 
                          <v-btn small color="green">
                            <v-icon
                              color="white"
                              @click="submitItem(props)"
                            >
                              check
                            </v-icon>
                            </v-btn>                       
                        </td>
                      </template>
                    </v-data-table>
                  </v-form>
                </div>
              </template>


            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-toolbar>
    <v-data-table
    disable-initial-sort
      :headers="headers"
      :items="entry"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs">{{ props.item.joules }}</td>
        <td class="text-xs">{{ new Date(props.item.createdAt).toLocaleString() }}</td>
        <td class="layout px-0">
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      item: [
        {
          joules: null
        },
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      dialog: false,
      headers: [
        {
          text: 'Joules',
          sortable: false,
          value: 'joules'
        },
        { text: 'Fecha', value: 'date' },
        { text: 'Eliminar',  value: 'name', sortable: false }
      ],
      headers2: [
        {
          text: 'Joules',
          align: 'left',
          sortable: false,
          value: 'joules'
        },
      ],
      entry: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Ingreso' : 'Edit Item'
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
      this.new()
    },
    methods: {
      new() {
        this.editedItem.date = `${new Date().getDate()}/${new Date().getMonth()}/${new Date().getFullYear()}`
        this.$axios.get("/api/Joules/", this.editedItem)
        .then(response => {
          console.log("resp", response)
          this.entry = response.data
        })
        .catch(e => {
          console.log(e);
        });
      },
      deleteItem (item) {
        const index = this.entry.indexOf(item)
        const _id = {
          _id: this.entry[this.entry.indexOf(item)]._id
        }
        confirm('¿Estas seguro que quieres eliminar este registro?') 
        let r =  confirm('¿Estas seguro que quieres eliminar este registro?')
        if (r == true) {
          this.entry.splice(index, 1)
          this.$axios.post("/api/DeleteJoulesReports/", _id)
        } 
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      submitItem(props) {
        console.log(props.item)
        console.log(props.index)

        alert("Registro enviado!!!")

        this.$axios.post("/api/Joules/", props.item)
        .then(response => {
          if( response.status === 200) {
            alert("Registro enviado!!!")
            console.log("responsessss", response)
            this.new()
          }
        })
        .catch(e => {
          console.log(e);
        });
        this.close()
      },
    }
  }
</script>

<style scoped>
  .v-card {
    padding: 30px !important;
  }
</style>
